import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const hasVideo: TComputedPropMapper<boolean> = ({ offer }) => {
  return Boolean(offer.videos && offer.videos.length > 0);
};
